'use strict';

import { Entity } from '../Entity';
import { User } from './User';

export class UserFlag extends Entity {
  protected flagId;
  protected flagColor;
  protected flagMeaning;
  protected flagDash;
  protected user;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.flagId = data.flagId;
    this.flagColor = data.flagColor;
    this.flagMeaning = data.flagMeaning;
    this.flagDash = data.flagDash;

    if (data.user) {
      const user = new User();
      user.hydrate(data.user);
      this.user = user;
    }
  }

  public getFlagId() {
    return this.flagId;
  }

  public getFlagColor() {
    return this.flagColor;
  }

  public getFlagMeaning() {
    return this.flagMeaning;
  }

  public getFlagDash() {
    return this.flagDash;
  }

  public getUser() {
    return this.user;
  }
}
